(function() {
    "use strict";
    angular.module("gardaSee", [

            // import module inetconsFilter
            "inetconsFilter",

            // import module inetcons url Service
            "inetconsFilterServices"
        ])
        .config([
            function() {}
        ])
        .controller("FilterController", [
            "$scope", "$element", "$document", "accosFilter", "accosHashUrlService", "accosUrlService", "shuffle", "$window", "$timeout", "cookie",
            function ($scope, $element, $document, accosFilter, accosHashUrlService, accosUrlService, shuffle, $window, $timeout, cookie) {
                var isMobile = false;
                var firstPageLoad = true;
                var boardingIds = [];
                var amenityIds = [];
                var filterdAccos = null;
                $scope.filter = $element.data("filter");
                accosUrlService.baseUrl = $element.data('baseurl');
                accosUrlService.accoTypeId = $scope.filter.AccoTypeId;
                accosUrlService.locationId = $scope.filter.ResortId;
                accosUrlService.themeId = $scope.filter.ThemeId;

                $scope.ajaxCount = null;
                $scope.showNoResults = false;

                $scope.accoTypeCount = function (id) {
                    if ($scope.ajaxCount != null) {
                        return $scope.ajaxCount.accoTypeCounts[id];
                    }
                    return 0;
                }
                $scope.locationCount = function (id) {
                    if ($scope.ajaxCount != null) {
                        return $scope.ajaxCount.areaCounts[id];
                    }
                    return 0;
                }
                $scope.boardingcount = function (id) {
                    if ($scope.ajaxCount != null) {
                        return $scope.ajaxCount.boardingCounts[id];
                    }
                    return 0;
                }
                $scope.amenitycount = function (id) {
                    if ($scope.ajaxCount != null) {
                        return $scope.ajaxCount.amenityCounts[id];
                    }
                    return 1;
                }
                $scope.resultsCount = function () {
                    //var list = document.getElementsByClassName('accos-items')[0];
                    //if (list) {
                    //    return list.childElementCount;
                    //}
                    if ($scope.ajaxCount != null) {
                        return $scope.ajaxCount.count;
                    }
                    return 1;
                }

                $scope.isAccoTypeActive = function (id) {
                    return $scope.filter.AccoTypeId === id && $scope.filter.ThemeId === 0;
                }
                $scope.isAreaActive = function (id) {
                    return $scope.filter.ResortId === id;
                }
                $scope.isThemeActive = function (id) {
                    return $scope.filter.ThemeId === id;
                }

                $scope.isAccoTypeDisabled = function (id) {
                    return $scope.accoTypeCount(id) == 0;
                }
                $scope.isAmenityDisabled = function(id) {
                    var count = $scope.amenitycount(id);
                    if (count == 0) {
                        return true;
                    }
                    return false;
                }
                $scope.isBoardingDisabled = function (id) {
                    var count = $scope.boardingcount(id);
                    if (count == 0) {
                        return true;
                    }
                    return false;
                }
                $scope.isLocationDisabled = function (id) {
                    //if (accosUrlService.accoTypeId == -1 && id != 0) {
                    //    return true;
                    //}
                    if (accosUrlService.themeId !== 0 && id !== 0) {
                        return true;
                    }
                    if (id === -1) {
                        return false;
                    }
                    return $scope.locationCount(id) === 0;
                }

                $scope.countVisibleLocations = function(defaultCount) {
                    var count = null;
                    if ($scope.ajaxCount != null) {
                        count = 0;
                        for (var id in $scope.ajaxCount.areaCounts) {
                            if ($scope.ajaxCount.areaCounts[id] !== 0) {
                                count++;
                            }
                        }
                    }
                    return count == null ? defaultCount : count;
                }

                $scope.mobile = {
                    filter: angular.element(".filter-mobile-fixed"),
                    body: $("body"),
                    url: "",
                    close: function() {
                        this.filter.removeClass("show");
                        this.body.removeClass("no-scroll");
                    },
                    open: function() {
                        this.filter.addClass("show");
                        this.body.addClass("no-scroll");
                        accosUrlService.getNewCount(amenityIds, boardingIds, updateCount);
                    },
                    ok: function () {
                        this.close();
                        //gaqPushFilterStatus(this.url);
                        if (this.url !== "") {
                            $window.location.href = this.url;
                        } else {
                            shuffle(accosFilter.rootElement, filterdAccos.getElements());
                            this.body.scrollTo(accosFilter.rootElement, 300);
                        }
                    },
                    reset: function() {
                        boardingIds = [];
                        amenityIds = [];
                        accosHashUrlService.gotofilterUrl(boardingIds, amenityIds);
                        accosUrlService.accoTypeId = 0;
                        accosUrlService.locationId = 0;
                        var url = accosUrlService.getUrl();
                        this.url = url;
                        accosUrlService.getNewCount(amenityIds, boardingIds, updateCount);
                    },
                    accoType: function () {
                        this.url = accosUrlService.getUrl();
                        accosUrlService.getNewCount(amenityIds, boardingIds, updateCount);
                        $("#enquiryqb-form").find("input[name='accotype']").val(accosUrlService.accoTypeId);
                        $("#enquiryqb-form").find("input[name='theme']").val(accosUrlService.themeId);
                    },
                    place: function () {
                        this.url = accosUrlService.getUrl(undefined, undefined, true);
                        accosUrlService.getNewCount(amenityIds, boardingIds, updateCount);
                        $("#enquiryqb-form").find("input[name='resort']").val(accosUrlService.locationId);
                    },
                    accoTypeUrl: function (id) {
                        if ($scope.accoTypeCount(id) == 0) {
                            return "";
                        }
                        return accosUrlService.getUrl(id);
                    },
                    locationUrl: function (id) {
                        if ($scope.locationCount(id) == 0) {
                            return "";
                        }
                        return accosUrlService.getUrl(undefined, id, true);
                    }
                }


                $scope.reset = function() {
                    accosHashUrlService.removeCookie();
                    $window.location.href = accosUrlService.getUrl(0, 0);
                }

                function updateCount(counts) {
                    $timeout(function () {
                        $scope.ajaxCount = counts;
                        $('.enquirybar-count').text(counts.count);
                    });
                }

                function resize() {
                    var mq = $window.matchMedia("(max-width: 991px)");
                    if (mq.matches) {
                        isMobile = true;
                    } else {
                        isMobile = false;
                        $scope.mobile.close();
                    }
                }
                //var clientId = null;
                //ga(function (tracker) {
                //    clientId = 'clientId:' + tracker.get('clientId');
                //});
                //function gaqPushFilterStatus(pathname) {
                //    var filterPath = cookie.get('accosUrlService');
                //    if (pathname) {
                //        var page = pathname + "?" + filterPath;

                //        ga('accosfilter.send', 'pageview', {
                //            page: page,
                //            'dimension1': clientId
                //        });

                //    } else if (filterPath) {
                //        var page = $window.location.pathname + "?" + filterPath;

                //        ga('accosfilter.send', 'pageview', {
                //            page: page,
                //            'dimension1': clientId
                //        });
                //    }
                //}

                angular.element($window).bind("resize", resize);
                $document.ready(function() {
                    resize();

                    // update enquirybar
                    var aid = $(".active[accotype-id]").attr("accotype-id");
                    var lid = $(".active[location-id]").attr("location-id");
                    $("#enquiryqb-form").find("input[name='accotype']").val(aid);
                    $("#enquiryqb-form").find("input[name='resort']").val(lid);
                    $("#enquiryqb-form").find("input[name='theme']").val(accosUrlService.themeId);

                    // Boardings
                    var boardingLis = angular.element(".js-boarding-ul").children();
                    angular.forEach(boardingLis, function(li) {
                        li = angular.element(li);

                        var id = li.attr("boarding-id");
                        var url = li.attr("boarding-url");
                        accosHashUrlService.addBoardingSet(id, url, function callbackChangeState(isActive) {
                            li.find(".item").toggleClass("active", isActive);
                        });

                        li.bind("click", function() {
                            var item = li.find(".item");
                            var id = li.attr("boarding-id");
                            if (item.hasClass("disabled") && !item.hasClass("active")) return;

                            var isActive = item.toggleClass("active").hasClass("active");

                            if (isActive) {
                                boardingIds.push(id);
                            } else {
                                for (var i = 0; i < boardingIds.length; i++) {
                                    if (boardingIds[i] == id) {
                                        boardingIds.splice(i, 1);
                                    }
                                }
                            }

                            accosHashUrlService.gotofilterUrl(boardingIds, amenityIds);
                        });
                    });

                    // Amenities
                    var amenityDivs = angular.element(".js-amenity-div").children();
                    angular.forEach(amenityDivs, function(div) {
                        var chackBox = angular.element(div).find(":checkbox");

                        var id = chackBox.attr("amenity-id");
                        var url = chackBox.attr("amenity-url");
                        accosHashUrlService.addAmenitySet(id, url, function callbackChangeState(isActive) {
                            chackBox.prop("checked", isActive);
                        });

                        chackBox.bind("change", function() {
                            var id = chackBox.attr("amenity-id");
                            if (chackBox.is(":checked")) {
                                amenityIds.push(id);
                            } else {
                                for (var i = 0; i < amenityIds.length; i++) {
                                    if (amenityIds[i] == id) {
                                        amenityIds.splice(i, 1);
                                    }
                                }
                            }
                            accosHashUrlService.gotofilterUrl(boardingIds, amenityIds);
                        });
                    });

                    // init accosHashUrlService callback
                    function initFilter() {
                        var accoFiltersettings = accosHashUrlService.parseUrl();
                        if (accoFiltersettings != undefined) {
                            boardingIds = accoFiltersettings.boardingIds;
                            amenityIds = accoFiltersettings.amenityIds;

                            //if (!isMobile) {
                            //    gaqPushFilterStatus();
                            //}
                        }

                        // do not show empty result
                        var boIds = [];
                        $scope.showNoResults = false;
                        for (var i in boardingIds) {
                            if (boardingIds.hasOwnProperty(i)) {
                                if (!$scope.isBoardingDisabled(+boardingIds[i])) {
                                    boIds.push(boardingIds[i]);
                                }
                            }
                        }
                        var amIds = [];
                        for (var i in amenityIds) {
                            if (amenityIds.hasOwnProperty(i)) {
                                if (!$scope.isAmenityDisabled(+amenityIds[i])) {
                                    amIds.push(amenityIds[i]);
                                } else {
                                    $scope.showNoResults = true;
                                }
                            }
                        }

                        if (firstPageLoad) {
                            boIds = boardingIds;
                            amIds = amenityIds;
                        }

                        $("#enquiryqb-form").find("input[name='boardingIds']").val(boIds.join(','));
                        $("#enquiryqb-form").find("input[name='amenityIds']").val(amIds.join(','));

                        // filter all accos in View
                        filterdAccos = accosFilter.filterByIds(boIds, amIds);

                        accosUrlService.getNewCount(amIds, boIds, updateCount);
                        if (!isMobile || firstPageLoad) {
                            shuffle(accosFilter.rootElement, filterdAccos.getElements());
                            firstPageLoad = false;
                        }
                    }

                    cookie.onChanged('accosUrlService', function() {
                        initFilter();
                    });
                    $scope.$apply(function() {
                        initFilter();
                    });

                });
            }
        ]);

})();
